import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UserDeviceCreateMutationVariables = Types.Exact<{
  input: Types.DeviceInput;
}>;


export type UserDeviceCreateMutation = { __typename?: 'Mutation', userDeviceCreate?: { __typename?: 'Device', id: string } | null };

export type UserDeviceDeleteMutationVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type UserDeviceDeleteMutation = { __typename?: 'Mutation', userDeviceDelete?: { __typename?: 'Device', id: string } | null };

export type UserRefuseGeolocationMutationVariables = Types.Exact<{
  input: Types.AdminUserUpdateInput;
}>;


export type UserRefuseGeolocationMutation = { __typename?: 'Mutation', adminUserUpdate?: { __typename?: 'User', id: string } | null };

export type UserSignOutMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type UserSignOutMutation = { __typename?: 'Mutation', userSignOut?: { __typename?: 'User', id: string } | null };

export const UserDeviceCreateDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userDeviceCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDeviceCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UserDeviceCreateGQL extends Apollo.Mutation<UserDeviceCreateMutation, UserDeviceCreateMutationVariables> {
    document = UserDeviceCreateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserDeviceDeleteDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userDeviceDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDeviceDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UserDeviceDeleteGQL extends Apollo.Mutation<UserDeviceDeleteMutation, UserDeviceDeleteMutationVariables> {
    document = UserDeviceDeleteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserRefuseGeolocationDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userRefuseGeolocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminUserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UserRefuseGeolocationGQL extends Apollo.Mutation<UserRefuseGeolocationMutation, UserRefuseGeolocationMutationVariables> {
    document = UserRefuseGeolocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserSignOutDocument = /*#__PURE__*/ {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"userSignOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSignOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;

  @Injectable({
    providedIn: 'root'
  })
  export class UserSignOutGQL extends Apollo.Mutation<UserSignOutMutation, UserSignOutMutationVariables> {
    document = UserSignOutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }